import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { storeUserHubs } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { useApiQuery } from './useApiQuery';

const useUserHubs = ({ useruuid, refetchInterval, refetchOnMount = true }) => {
  const dispatch = useDispatch();
  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  const query = useApiQuery(
    ['userHubs', useruuid],
    () =>
      new Promise((resolve, reject) => {
        userApi.getUserHubsById(
          useruuid,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              dispatch(storeUserHubs({ userHubs: data?.userhubs, useruuid }));
              resolve(data?.userhubs ?? []);
            },
            errorCallback: (err) => {
              reject(err);
            },
          })
        );
      }),
    { enabled: !!useruuid, refetchInterval, refetchOnMount, staleTime: 0 }
  );

  useEffect(() => {
    // this is needed if data is there in cache and trigger dispatch
    if (query.data) {
      dispatch(storeUserHubs({ userHubs: query?.data, useruuid }));
    }
  }, [query.data, dispatch, useruuid]);

  return query;
};

export default useUserHubs;
